import jessibucaDemo from "./JessibucaDemo.vue";
import tableCom from "./tableCom.vue";

//把通用组件引入然后注册后暴露出去，main文件中引入然后注册成全局组件
const components = {
  jessibucaDemo,
  tableCom
};
export default components;
